import { render, staticRenderFns } from "./ImagePercentageBar.vue?vue&type=template&id=fb1b5972&scoped=true&"
import script from "./ImagePercentageBar.vue?vue&type=script&lang=js&"
export * from "./ImagePercentageBar.vue?vue&type=script&lang=js&"
import style0 from "./ImagePercentageBar.vue?vue&type=style&index=0&id=fb1b5972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1b5972",
  null
  
)

export default component.exports